import { PageHeaderLayoutContext } from 'pages/Project/Common/Layouts/PageLayoutContext';

import { debounce } from 'debounce';
import { useCallback, useContext, useMemo, useState } from 'react';

export const useViewport = (indentsGetter?: (isContextHeaderOpen: boolean, isMainFieldsOpen: boolean) => string) => {
    const { isHeaderOpened } = useContext(PageHeaderLayoutContext);

    const [isGroupContentScrolled, setIsGroupContentScrolled] = useState(false);
    const [isMainFieldsOpen, setIsMainFieldsOpen] = useState<boolean>(true);

    const switchMainFieldsOpen = useCallback(() => {
        setIsMainFieldsOpen(!isMainFieldsOpen);
    }, [isMainFieldsOpen]);

    const debouncedScroll = useMemo(
        () =>
            debounce((e: any) => {
                setIsGroupContentScrolled(!!e.target.scrollTop);
            }, 50),
        [],
    );

    const topIndention = useMemo(() => {
        if (indentsGetter) {
            return indentsGetter(isHeaderOpened, isMainFieldsOpen);
        }

        if (!isHeaderOpened && !isMainFieldsOpen) {
            return '-210px';
        }
        if (isHeaderOpened && isMainFieldsOpen) {
            return '150px';
        }
        if (isHeaderOpened && !isMainFieldsOpen) {
            return '-48px';
        }
        if (!isHeaderOpened && isMainFieldsOpen) {
            return '-13px';
        }

        return '';
    }, [indentsGetter, isHeaderOpened, isMainFieldsOpen]);

    return {
        topIndention,
        debouncedScroll,
        isGroupContentScrolled,
        isMainFieldsOpen,
        switchMainFieldsOpen,
    };
};
